import { render } from "./stockIn.vue?vue&type=template&id=47624820&scoped=true"
import script from "./stockIn.vue?vue&type=script&lang=js"
export * from "./stockIn.vue?vue&type=script&lang=js"

import "./stockIn.vue?vue&type=style&index=0&id=47624820&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47624820"

export default script